import React from 'reactn';
import { UnidadBase } from './UnidadBase.atomo';
export const UnidadCajas = (props) => <UnidadBase {...props} unidad="Cajas"/>
export const UnidadCj = (props) => <UnidadBase {...props} unidad="Cj"/>